export default "__VITE_PUBLIC_ASSET__e7dbeb07__"